// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_GMK","cls2":"PodcastLibraryCarouselAd-cls2_dDL PodcastLibraryCarouselAd-cls1_GMK"};